/* (ignored) */


//////////////////
// WEBPACK FOOTER
// jsdom (ignored)
// module id = 2
// module chunks = main